import Service from '@/api/Service'
import { DEVTYPE } from '@/api/configData'

const baseData = {
    state: {
        tmpProject: [],    // 项目类型
        regionsData: [],    // 城市区域列表
        chargeScheme: [],   // 计费方案
        devtype: DEVTYPE,   //  表计类型
        roleModule: {},     //  权限模块
    },
    mutations: {
        GET_PROJECTTYPE: (state, tmpProject) => {
            state.tmpProject = tmpProject
        },
        GET_REGIONSDATA: (state, regionsData) => {
            state.regionsData = regionsData
        },
        GET_CHARGESCHEME: (state, chargeScheme) => {
            state.chargeScheme = chargeScheme
        },
        GET_ROLEMODULE: (state, roleModule) => {
            state.roleModule = roleModule
        },
    },
    actions: {
        // 获取项目模型
        async getTemplateList({ commit }) {
            let data = await Service.getTemplateList();
            return new Promise((resolve, reject) => {
                if (data) {
                    commit('GET_PROJECTTYPE', data.list)
                    resolve(data.list)
                } else {
                    reject()
                }
            })
        },
        // 获取城市区域列表
        async getRegionsData({ commit, state }, val) {
            let idArea 
            let cascaderData = state.regionsData
            let sizeArea
			let data
            if (!val) {
                idArea = null
                sizeArea = 0
				// data= await Service.getProvince()
            } else if (val.length === 1) {
                idArea = val[0]
				// data= await Service.getCity({oid: idArea});
                sizeArea = val.length // 3:一级 4:二级 6:三级
            } else if (val.length === 2) {
                idArea = val[1]
                sizeArea = val.length // 3:一级 4:二级 6:三级
            }
            let OID = val ? val[val.length - 1] : '7459';
			// data= await Service.getProvince()
            if (sizeArea === 0) { // 初始化 加载一级 省
                cascaderData = data
            } else if (sizeArea === 1) { // 点击一级 加载二级 市

                cascaderData.map((value) => {
                    if (value.oid === val[0]) {
                        // if (!value.cities.length) {
                        //     
                        // }
						value.cities = data
                    }
                })
            } else if (sizeArea === 2) { // 点击二级 加载三级 区
                cascaderData.map((value) => {
                    if (value.oid === val[0]) {
                        value.cities.map((value) => {
                            if (value.oid === val[1]) {
                                if (!value.cities.length) {
                                    value.cities = data
                                }
                            }
                        })
                    }
                })
            }
            //返回一个新的对象
            return new Promise((resolve, reject) => {
                if (data) {
                    commit('GET_REGIONSDATA', cascaderData)
                    resolve(data)
                } else {
                    reject()
                }
            })
        },
        // 获取方案列表
        async getChargeScheme({ commit }) {
            let data = await Service.getChargeSchemeList({});
            return new Promise((resolve, reject) => {
                if (data) {
                    data = data == 'success' ? [] : data;
                    commit('GET_CHARGESCHEME', data)
                    resolve(data)
                } else {
                    reject()
                }
            })
        },
        // 获取权限模块
        async getRoleModule({ commit }) {
            let data = await Service.getRoleModuleList({});
            return new Promise((resolve, reject) => {
                data = data == 'success' ? [] : data;
                if (data) {
                    let roleModule = {}
                    data.map(v=>{
                        roleModule[v.ModuleKey] = v.ModuleName
                    })
                    commit('GET_ROLEMODULE', roleModule)
                    resolve(data)
                } else {
                    reject()
                }
            })
        },
    }
}

export default baseData
